/**
 * 分区计量（DMAPartitionMetering）模块英文映射（中文原文 → 英文 扁平映射）
 * 覆盖范围：src/views/DMAPartitionMetering/ 第 1 组（PipelineManagement、PipelineNetMap/IoTConfiguration、PipeNetwork 编辑器、PipelineVersionManagement）
 * 术语：分区计量=District Metering，管网=Pipe Network，漏损=Leakage，压力=Pressure，流量=Flow
 * 通用词（确定/取消/关闭/查询/重置/编辑/操作/创建人 等）已在 en-US.js 中定义，此处不再重复
 */
export default {
  // IoTConfiguration / 物联设备
  '物联设备': 'IoT Device',
  '物联信息': 'IoT Info',
  '物联代码': 'IoT Code',
  '物联名称': 'IoT Name',
  '选择物联设备': 'Select IoT Device',
  '请选择物联设备': 'Please select an IoT device',
  '请选择物联设备！': 'Please select an IoT device!',
  '设备ID': 'Device ID',
  '请输入设备ID': 'Please enter device ID',
  '设备代码': 'Device Code',
  '设备名称': 'Device Name',
  '安装位置': 'Installation Location',
  '压力': 'Pressure',
  '压力(Mpa)': 'Pressure (MPa)',
  '温度': 'Temperature',
  '温度(℃)': 'Temperature (℃)',
  '电压': 'Voltage',
  '电压(V)': 'Voltage (V)',
  '信号': 'Signal',
  '信号(%)': 'Signal (%)',
  '最新上报时间': 'Last Report Time',
  '最新上报值': 'Last Reported Value',
  '序号': 'No.',
  '代码': 'Code',
  '名称': 'Name',
  '类型': 'Type',
  '表编号': 'Meter No.',
  '累计用量': 'Cumulative Usage',
  '累计用量(m³)': 'Cumulative Usage (m³)',
  '结算日流量': 'Settlement Daily Flow',
  '结算日流量(m³)': 'Settlement Daily Flow (m³)',
  '表端剩余金额': 'Meter Remaining Balance',
  '表端剩余金额(元)': 'Meter Remaining Balance (CNY)',
  '转换系数': 'Conversion Coefficient',
  '请输入转换系数': 'Please enter conversion coefficient',
  '历史数据': 'Historical Data',
  '历史数据曲线图': 'Historical Data Curve',
  '确定解绑吗?': 'Are you sure to unbind?',
  '解绑': 'Unbind',
  '节点信息': 'Node Info',
  '节点代码': 'Node Code',
  '节点名称': 'Node Name',
  '节点类型': 'Node Type',
  '请选择节点类型': 'Please select node type',
  '时间范围': 'Time Range',
  '请选择时间范围': 'Please select time range',
  '请选择时间范围！': 'Please select time range!',
  '已选:': 'Selected:',
  '项目': 'Project',
  '请选择项目': 'Please select project',
  '压力计': 'Pressure Gauge',
  '水表': 'Water Meter',
  '阀门': 'Valve',
  '消防栓': 'Fire Hydrant',
  '水塔': 'Water Tower',
  '加压泵': 'Booster Pump',
  '流量计': 'Flow Meter',
  '液位计': 'Liquid Level Gauge',
  // PipeNetworkEditing / 管网地图
  '缩放级别:': 'Zoom Level:',
  '未点击到管线，请重新点击管线': 'No pipeline clicked, please click a pipeline again',
  '操作失败:': 'Operation failed:',
  '操作失败: ': 'Operation failed: ',
  '更新申请': 'Update Application',
  // PipelineVersionManagement / 拓扑版本管理
  '新增项目': 'Add Project',
  '编辑项目': 'Edit Project',
  '新增拓扑': 'Add Topology',
  '编辑拓扑': 'Edit Topology',
  '拓扑代码': 'Topology Code',
  '查看': 'View',
  '确定启用吗?': 'Are you sure to enable?',
  '启用': 'Enabled',
  '启用成功！': 'Enabled successfully!',
  '是否启用': 'Enabled',
  '未启用': 'Not Enabled',
  '已启用': 'Enabled',
  '创建日期': 'Created Date',
  '更新日期': 'Updated Date',
}
